import React from "react";
import AccountLayout from "../../account/AccountLayout";
import { AccountCard } from "../../account/AccountUi";
import Link from "../../components/Link";

export default function AccountNotFoundPage() {
  return (
    <AccountLayout title="Page not found" description="This account page does not exist." path="/account">
      <AccountCard>
        <p className="text-sm text-muted">That account URL is not available.</p>
        <Link
          to="/account"
          className="mt-4 inline-flex min-h-11 items-center text-sm font-semibold text-ink underline underline-offset-4"
        >
          Back to overview
        </Link>
      </AccountCard>
    </AccountLayout>
  );
}
